// extracted by mini-css-extract-plugin
export default {"menu-wrapper":"style__menu-wrapper--m4B0b","menuWrapper":"style__menu-wrapper--m4B0b","menu":"style__menu--P40_5"};